module.exports = __webpack_public_path__ + "img/frame (217).18d5abac.jpg";